import moment from "moment";
import {
  activeVersion,
  sampleCodes,
  sampleVersions,
} from "pages/PayRoll/Configuration/StatutoryConfiguration/PF/pfConfigData";

// Sample PF members and settings for the PF Reports tabs (ECR, Register,
// monthly summary) until the PF Reports APIs exist. The PF Members screen
// itself uses the PF Members APIs (Statutory/PF/pfMembersApi.js).

export const pfSettings = () => {
  const version = activeVersion(sampleVersions());
  return {
    ceiling: Number(version.wage_ceiling),
    epsCap: Number(version.eps_cap),
    stopAge: Number(version.eps_stop_age),
    // Sample rates (the PF version keeps rates inside its formulas).
    eeRate: 0.12,
    erRate: 0.13,
    epsRate: 0.0833,
    vpfEnabled: Boolean(version.vpf_enabled),
    vpfMaxPct: Number(version.vpf_max_pct),
    actualAllowed: Boolean(version.vpf_on_actual_allowed),
    optOutAllowed: Boolean(version.opt_out_allowed),
  };
};

const CODES = sampleCodes();
export const codeForLocation = (location) => CODES.find((code) => code.status === "Active" && code.locations.includes(location)) || null;

const member = (id, name, department, location, extra = {}) => ({
  id,
  name,
  department,
  location,
  uan: "",
  dob: "1990-01-01",
  joined_pf: "2020-04-01",
  pf_wage: 15000,
  status: "Member",
  eps_member: "YES",
  eps_source: "AT_JOINING",
  previous_pf_member: false,
  full_salary: false,
  extra_amount: 0,
  extra_from: "",
  extra_letter: "",
  extra_set_by: "",
  opt_out_from: "",
  opt_out_reason: "",
  opt_out_form11: "",
  ...extra,
});

// The eight people on the mockups, then enough others to reach the
// mockup's totals (156 employees: 149 members, 7 opted out).
const NAMED = [
  member("E001", "Ravi Kumar", "Production", "Erode Plant", {
    uan: "100123456789", dob: "1990-03-09", joined_pf: "2019-04-01", pf_wage: 30000,
    full_salary: true, extra_amount: 1000, extra_from: "2026-10", extra_set_by: "Sadheesh",
  }),
  member("E002", "Anjali Sharma", "Production", "Erode Plant", { uan: "100234567890", dob: "1995-07-14", joined_pf: "2020-02-01", pf_wage: 11250 }),
  member("E003", "Suresh B", "Finance", "Chennai Office", { uan: "100345678901", dob: "1968-02-02", joined_pf: "2008-06-01", pf_wage: 9800 }),
  member("E004", "Priya N", "Production", "Erode Plant", { uan: "100456789012", dob: "1998-11-21", joined_pf: "2021-01-01", pf_wage: 6250 }),
  member("E009", "Manish T", "Production", "Erode Plant", { uan: "", dob: "2001-01-05", joined_pf: "2026-10-10", pf_wage: 8000 }),
  member("E041", "Kumar P", "Sales", "Erode Office", {
    uan: "", dob: "1988-06-11", joined_pf: "", pf_wage: 32000, status: "Opted out", eps_member: "NO",
    opt_out_from: "Date of joining", opt_out_reason: "Employee chose not to join PF",
  }),
  member("E010", "Divya R", "Production", "Erode Plant", { uan: "100567890123", dob: "", joined_pf: "2022-03-01", pf_wage: 9450 }),
  member("E117", "Imran S", "Stores", "Chennai Office", { uan: "100678901234", dob: "1993-08-30", joined_pf: "2019-07-01", pf_wage: 27500, eps_member: "NO" }),
];

const FIRST = ["Arun", "Bala", "Chitra", "Deepa", "Elango", "Fathima", "Gokul", "Hari", "Indhu", "Jaya", "Karthi", "Lakshmi", "Mohan", "Nithya", "Prabhu", "Revathi", "Saravanan", "Tamil", "Uma", "Vignesh"];
const LAST = ["K", "M", "R", "S", "P", "V", "A", "N"];
const DEPARTMENTS = ["Production", "Production", "Production", "Stores", "Quality", "Maintenance", "Finance", "Sales"];
const LOCATIONS = ["Erode Plant", "Erode Plant", "Erode Office", "Chennai Office"];

const filler = () => {
  const list = [];
  for (let index = 0; list.length < 148; index += 1) {
    const number = 200 + index;
    const name = `${FIRST[index % FIRST.length]} ${LAST[Math.floor(index / FIRST.length) % LAST.length]}`;
    const optedOut = index % 25 === 7 && list.filter((item) => item.status === "Opted out").length < 6;
    const uanMissing = index === 41;
    list.push(
      member(`E${number}`, name, DEPARTMENTS[index % DEPARTMENTS.length], LOCATIONS[index % LOCATIONS.length], {
        uan: optedOut || uanMissing ? "" : String(100700000000 + index * 137),
        dob: moment("1975-01-15").add(index * 97, "days").format("YYYY-MM-DD"),
        joined_pf: optedOut ? "" : moment("2015-04-01").add(index * 23, "days").format("YYYY-MM-DD"),
        pf_wage: 6000 + ((index * 1373) % 22000),
        status: optedOut ? "Opted out" : "Member",
        eps_member: optedOut ? "NO" : "YES",
        opt_out_from: optedOut ? "Date of joining" : "",
        opt_out_reason: optedOut ? "Employee chose not to join PF" : "",
      }),
    );
  }
  return list;
};

export const sampleMembers = () => [...NAMED, ...filler()];
